import React, { useContext, useEffect, useState, useMemo } from 'react';
import { isUser, myTickets, getLotteryTicket } from '../services/userServices';
import CssEditor from './CssEditor';
import AdminLogin from './AdminLogin';
import { UserContext } from '../contexts/UserContext';
import TurnstileCaptcha from './Captcha';
import config from '../config';
import settings from '../Setting.json';

function FlipClock({ target }) {
  const parseTarget = () => {
    try { return new Date(target); } catch { return null; }
  };
  const targetDate = parseTarget();
  const calc = () => {
    const now = new Date().getTime();
    const end = targetDate ? targetDate.getTime() : now;
    const diff = Math.max(0, end - now);
    const day = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hour = Math.floor((diff / (1000 * 60 * 60)) % 24);
    const min = Math.floor((diff / (1000 * 60)) % 60);
    const sec = Math.floor((diff / 1000) % 60);
    return { day, hour, min, sec };
  };
  const [time, setTime] = useState(calc());
  const [prev, setPrev] = useState(time);
  const [flip, setFlip] = useState({ day: false, hour: false, min: false, sec: false });

  useEffect(() => {
    const id = setInterval(() => {
      const next = calc();
      setPrev(time);
      setTime(next);
      setFlip({
        day: next.day !== time.day,
        hour: next.hour !== time.hour,
        min: next.min !== time.min,
        sec: next.sec !== time.sec,
      });
      setTimeout(() => setFlip({ day: false, hour: false, min: false, sec: false }), 650);
    }, 1000);
    return () => clearInterval(id);
    // eslint-disable-next-line
  }, [target, time]);

  const pad = (v) => String(v).padStart(2, '0');

  const Piece = ({ value, prevValue, label, flipOn }) => (
    <span className={`flip-clock__piece ${flipOn ? 'flip' : ''}`}>
      <b className="flip-clock__card card">
        <b className="card__top">{pad(value)}</b>
        <b className="card__bottom" data-value={pad(prevValue)}></b>
        <b className="card__back" data-value={pad(value)}>
          <b className="card__bottom" data-value={pad(value)}></b>
        </b>
      </b>
      <span className="flip-clock__slot">{label}</span>
    </span>
  );

  return (
    <div className="flip-clock">
      <Piece value={time.day} prevValue={prev.day} label="Gün" flipOn={flip.day} />
      <Piece value={time.hour} prevValue={prev.hour} label="Saat" flipOn={flip.hour} />
      <Piece value={time.min} prevValue={prev.min} label="Dakika" flipOn={flip.min} />
      <Piece value={time.sec} prevValue={prev.sec} label="Saniye" flipOn={flip.sec} />
    </div>
  );
}

export default function IsUser() {
  const [username, setUsername] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [isSuccessMessage, setIsSuccessMessage] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [showAdmin, SetShowAdmin] = useState(false);

  const [mobileOpen, setMobileOpen] = useState(false);
  const [winnersOpen, setWinnersOpen] = useState(false);
  const [ticketsOpen, setTicketsOpen] = useState(false);
  const [activeTicketTab, setActiveTicketTab] = useState('active');
  const [cssEditorOpen, setCssEditorOpen] = useState(false);

  const [tickets, setTickets] = useState({ active: [], winners: [], loses: [] });

  const { captcha, lotteryData, userId } = useContext(UserContext) || {};

  

  useEffect(() => {
    // Admin route detection - check for /admin or /id/admin pattern
    const pathname = window.location.pathname;
    console.log('Current pathname:', pathname);
    console.log('Checking admin pattern...');
    
    // Check if pathname ends with /admin
    if (pathname.endsWith('/admin')) {
      console.log('Admin route detected!');
      setIsAdmin(true);
      SetShowAdmin(true);
      // Keep all existing data and states - don't reset anything
      console.log('Keeping existing data for admin route');
    } else {
      console.log('No admin route detected');
      // Reset admin state if not on admin route
      setIsAdmin(false);
      SetShowAdmin(false);
      setCssEditorOpen(false);
    }
  }, []);

  const handleAdminLogin = () => { 
    console.log('🔓 Admin login successful, opening CSS editor...')
    SetShowAdmin(false); 
    setCssEditorOpen(true); // CSS editörünü aç
    console.log('CSS editor state set to:', true)
  };
  const handleCloseLogin = () => { SetShowAdmin(false); };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsSuccessMessage(false);
    setLoading(true);
    try {
      const result = await isUser(username, null);
      if (result.status === true) {
        // Biletleri göster
        setActiveTicketTab('active');
        setTicketsOpen(true);
        const msg = result?.message ?? result?.success_message ?? '';
        if (msg) { setError(msg); setIsSuccessMessage(true); }
      } else {
        const msg = result?.message ?? result?.error ?? '';
        setError(msg);
        setIsSuccessMessage(false);
      }
    } catch (err) {
      console.error('API Error:', err);
      const serverMessage = err?.response?.data?.message || err?.response?.data?.error || err?.message || '';
      setError(serverMessage);
      setIsSuccessMessage(false);
    } finally {
      setLoading(false);
      if (window.resetCaptcha) window.resetCaptcha();
    }
  };

  const handleRequestTicket = async () => {
    if (!username.trim()) {
      setError('Lütfen önce kullanıcı adınızı girin.');
      return;
    }
    
    setError('');
    setIsSuccessMessage(false);
    setLoading(true);
    try {
      const tier = lottery?.id || 1;
      const processId = lottery?.process || 'cekilis';
      const resp = await getLotteryTicket(userId, tier, processId);
      const ok = resp?.status === true || resp?.success === true;
      if (ok) {
        const msg = resp?.message ?? resp?.success_message ?? 'Bilet talebiniz başarıyla oluşturuldu!';
        setError(msg);
        setIsSuccessMessage(true);
        
        // Biletleri yeniden çek ve modal'ı aç
        setActiveTicketTab('active');
        setTicketsOpen(true);
        
        // Biraz gecikme ile yeniden çek (API'nin güncellemesi için)
        setTimeout(() => {
          setTicketsOpen(false);
          setTimeout(() => {
            setTicketsOpen(true);
          }, 100);
        }, 500);
      } else {
        const msg = (resp?.message ?? resp?.error ?? 'Bilet talebi oluşturulamadı.');
        setError(msg);
        setIsSuccessMessage(false);
      }
    } catch (err) {
      console.error('Ticket Request Error:', err);
      const serverMessage = err?.response?.data?.message || err?.response?.data?.error || err?.message || 'Bilet talebi sırasında bir hata oluştu.';
      setError(serverMessage);
      setIsSuccessMessage(false);
    } finally {
      setLoading(false);
    }
  };

  const tabButtonClass = (key) => key === activeTicketTab
    ? 'flex-1 px-6 py-4 text-white font-medium border-b-2 border-[#b71b1b]'
    : 'flex-1 px-6 py-4 text-gray-400 font-medium hover:text-white';

  // Derived UI data from lottery API
  const lottery = useMemo(() => {
    try { 
      const data = lotteryData?.data?.[0] || null;
      console.log('Lottery data in useMemo:', data);
      return data;
    } catch (error) { 
      console.error('Error in lottery useMemo:', error);
      return null; 
    }
  }, [lotteryData]);

  const apiOrigin = useMemo(() => {
    try { return new URL(config.apiBaseUrlAdvanced).origin; } catch { return config.imgUrl; }
  }, []);

  const topBannerUrl = useMemo(() => {
    const url = config.imgUrl + lottery?.image;
    if (!url || typeof url !== 'string') return '';
    if (url.startsWith('http')) return url;
    return `${apiOrigin}${url}`;
  }, [lottery, apiOrigin]);

  const miniBadgeText = lottery?.tier_name || '';

  const howToBullets = useMemo(() => {
    const parts = [
      ...(lottery?.info?.infoItems || []),
      ...(lottery?.info?.rules || []),
      ...(lottery?.info?.security || []),
    ].filter((s) => typeof s === 'string' && s.trim().length > 0);
    return parts.length ? parts : [];
  }, [lottery]);

  // Fetch user's tickets when modal opens
  useEffect(() => {
    const fetchMyTickets = async () => {
      try {
        const tier = lottery?.id || 1;
        const resp = await myTickets(tier, userId);
        const list = Array.isArray(resp?.data) ? resp.data : (Array.isArray(resp) ? resp : []);
        
        // Status'a göre biletleri ayır
        // status = 1: Bekleyen bilet
        // status = 2: Kaybeden bilet
        // status = 3: Kazanan bilet
        const activeTickets = [];
        const winnerTickets = [];
        const loserTickets = [];
        
        list.forEach((t) => {
          const ticket = {
            code: t.ticket_no || t.code || String(t.id || '—'),
            status: t.status,
            date: t.created_at || t.date || '',
            amount: t.amount || ''
          };
          
          if (t.status === 1) {
            activeTickets.push(ticket);
          } else if (t.status === 3) {
            winnerTickets.push(ticket);
          } else if (t.status === 2) {
            loserTickets.push(ticket);
          }
        });
        
        setTickets({
          active: activeTickets,
          winners: winnerTickets,
          loses: loserTickets
        });
      } catch (e) {
        console.error('Fetch myTickets error:', e);
        setError('Biletler alınamadı. Lütfen tekrar deneyin.');
      }
    };

    if (ticketsOpen && userId) {
      fetchMyTickets();
    }
  }, [ticketsOpen, userId, lottery]);

  const heroTitle = lottery?.title || '';
  const heroSubtitle = lottery?.info?.description || '';
  const howToTitle = 'Nasıl Katılırım?';
  const countdownTarget = lottery?.result_date || lottery?.endDate || '';
  const howToDescription = lottery?.info?.howToPlay?.description || lottery?.info?.description || '';
  
  // Debug logs for admin route
  console.log('Current admin state:', { isAdmin, showAdmin, cssEditorOpen });
  console.log('Current lottery data:', lottery);
  console.log('Current hero title:', heroTitle);
  console.log('Current hero subtitle:', heroSubtitle);
  const prizesList = useMemo(() => (
    (lottery?.info?.prizes || []).filter((s) => typeof s === 'string' && s.trim().length > 0)
  ), [lottery]);
  const consolation = lottery?.info?.consolationPrizes || {};
  const consolationTitle = consolation?.title || 'Teselli Ödülleri';
  const consolationDesc = consolation?.description || '';
  const consolationTiers = useMemo(() => (
    (consolation?.tiers || []).filter((s) => typeof s === 'string' && s.trim().length > 0)
  ), [consolation]);

  return (
    <div className="min-h-screen text-white" style={{
      background: 'transparent',
      color: 'var(--text-color, #ffffff)',
      fontFamily: 'var(--font-family, Poppins)'
    }} id="main-container">
      <header className="absolute inset-x-0 top-0 z-50">
        <nav className="mx-auto max-w-7xl px-6 lg:px-8 pt-5" aria-label="Global">
          <div className="flex items-center justify-center py-0">
            <a href="#" className="-m-1.5 p-1.5">
              <span className="sr-only">Bigo</span>
              <img className="h-20 sm:h-24 md:h-28 w-auto" src="/logo.png" alt="Logo" />
            </a>
          </div>
        </nav>
      </header>

      {/* Hero */}
      <div className="relative isolate pt-14">
        {/* Background gradient blobs */}
        <div className="absolute inset-x-0 -top-40 -z-10 transform-gpu overflow-hidden blur-3xl sm:-top-80" aria-hidden="true">
          <div className="relative left-[calc(50%-11rem)] w-[36.125rem] -translate-x-1/2 rotate-[30deg] bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-20 sm:left-[calc(50%-30rem)] sm:w-[72.1875rem]" style={{ clipPath: 'polygon(74.1% 44.1%,100% 61.6%,97.5% 26.9%,85.5% 0.1%,80.7% 2%,72.5% 32.5%,60.2% 62.4%,52.4% 68.1%,47.5% 58.3%,45.2% 34.5%,27.5% 76.7%,0.1% 64.9%,17.9% 100%,27.6% 76.8%,76.1% 97.7%,74.1% 44.1%)' }} />
        </div>
        <div className="py-16 sm:py-24 lg:pb-20 hero-section" style={{
          background: 'transparent'
        }}>
          <div className="mx-auto max-w-7xl px-6 lg:px-8">
            <div className="mx-auto max-w-2xl text-center">
              <h1 className="text-balance mx-auto max-w-2xl text-2xl sm:text-4xl lg:text-6xl font-bold tracking-tight leading-tight" style={{
                color: 'var(--hero-title, #ffffff)',
                fontFamily: 'var(--font-family, Poppins)'
              }}>{heroTitle}</h1>
              <p className="mt-4 mx-auto max-w-xl text-pretty text-base font-medium sm:text-lg leading-7" style={{
                color: 'var(--hero-subtitle, #cccccc)',
                fontFamily: 'var(--font-family, Poppins)'
              }}>{heroSubtitle}</p>

              {/* Form */}
              <form className="mt-8 flex flex-col items-center justify-center gap-4" onSubmit={handleSubmit}>
                <div className="w-full sm:w-auto">
                  <input id="username" type="text" placeholder={settings?.inputPlaceholder || 'Kullanıcı Adı'} className="w-full px-4 py-2.5 text-base font-medium rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent" required value={username} onChange={(e) => setUsername(e.target.value)} disabled={loading} style={{
                    backgroundColor: 'var(--form-input-bg, #000000)',
                    border: '2px solid var(--form-input-border, #333333)',
                    color: 'var(--form-input-text, #ffffff)',
                    borderRadius: 'var(--button-radius, 8px)',
                    padding: 'var(--button-padding, 12px) 16px'
                  }} />
                </div>
                <div className="flex flex-col gap-3 w-full sm:w-auto">
                  <button type="submit" className="cursor-pointer w-full px-6 py-2.5 text-base font-semibold rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 focus:ring-offset-gray-900" disabled={loading} style={{
                    backgroundColor: 'var(--form-button-bg, #b71b1b)',
                    color: 'var(--form-button-text, #ffffff)',
                    border: '2px solid var(--form-button-border, #b71b1b)',
                    borderRadius: 'var(--button-radius, 8px)',
                    padding: 'var(--button-padding, 12px) 24px'
                  }} onMouseEnter={(e) => e.target.style.backgroundColor = 'var(--form-button-hover, #a61919)'} onMouseLeave={(e) => e.target.style.backgroundColor = 'var(--form-button-bg, #b71b1b)'}>
                    {loading ? 'Kontrol Ediliyor...' : (settings?.submitButtonText || 'Biletleri Gör')}
                  </button>
                  <button type="button" onClick={handleRequestTicket} className="cursor-pointer w-full px-6 py-2.5 text-base font-semibold rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 focus:ring-offset-gray-900" disabled={loading} style={{
                    backgroundColor: 'var(--form-secondary-button-bg, #2d5aa0)',
                    color: 'var(--form-secondary-button-text, #ffffff)',
                    border: '2px solid var(--form-secondary-button-border, #2d5aa0)',
                    borderRadius: 'var(--button-radius, 8px)',
                    padding: 'var(--button-padding, 12px) 24px'
                  }}>
                    Bilet Talep Et
                  </button>
                </div>
              </form>

              {/* Error/Success Message */}
              {error && (
                <div className={`mt-4 px-4 py-3 rounded-lg text-center ${isSuccessMessage ? 'bg-green-900/20 border border-green-500/50 text-green-400' : 'bg-red-900/20 border border-red-500/50 text-red-400'}`}>
                  {error}
                </div>
              )}

              {/* winners link removed as requested */}
            </div>
            <img src={topBannerUrl} alt="App screenshot" width="2432" height="1442" className="mt-8 rounded-md bg-white/5 ring-1 shadow-2xl ring-white/10 sm:mt-12 cursor-pointer" />
          </div>
        </div>
        <div className="absolute inset-x-0 top-[calc(100%-13rem)] -z-10 transform-gpu overflow-hidden blur-3xl sm:top-[calc(100%-30rem)]" aria-hidden="true">
          <div className="relative left-[calc(50%+3rem)] w-[36.125rem] -translate-x-1/2 bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-20 sm:left-[calc(50%+36rem)] sm:w-[72.1875rem]" style={{ clipPath: 'polygon(74.1% 44.1%,100% 61.6%,97.5% 26.9%,85.5% 0.1%,80.7% 2%,72.5% 32.5%,60.2% 62.4%,52.4% 68.1%,47.5% 58.3%,45.2% 34.5%,27.5% 76.7%,0.1% 64.9%,17.9% 100%,27.6% 76.8%,76.1% 97.7%,74.1% 44.1%)' }} />
        </div>
      </div>

      {/* TIMER */}
      <div style={{ background: 'transparent' }}>
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <div className="mx-auto max-w-4xl text-center">
            <h2 className="text-3xl font-bold tracking-tight sm:text-4xl" style={{ color: 'var(--countdown-title, #ffffff)' }}>{settings?.countdown?.title || 'Çekilişe Kalan Süre'}</h2>
            <div id="countdownTimer" className="mt-8"><FlipClock target={countdownTarget} /></div>
          </div>
        </div>
      </div>

      {/* ASK */}
      <div className="overflow-hidden py-8 sm:py-32" style={{ background: 'transparent' }}>
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <div className="mx-auto grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 sm:gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-2">
            <div className="lg:pt-4 lg:pr-8">
              <div className="lg:max-w-lg">
                <h2 className="text-sm font-semibold" style={{ color: 'var(--how-to-badge, #b71b1b)' }}>{miniBadgeText}</h2>
                <p className="mt-2 text-4xl font-semibold tracking-tight sm:text-5xl" style={{ color: 'var(--how-to-title, #ffffff)' }}>{howToTitle}</p>
                <dl className="mt-10 max-w-xl space-y-8 text-base text-gray-300 lg:max-w-none">
                  {howToBullets.slice(0, 6).map((text, idx) => (
                    <div key={idx} className="relative pl-9">
                      <dt className="inline font-semibold" style={{ color: 'var(--how-to-title, #ffffff)' }}>
                        <svg className="absolute top-1 left-1 w-5 h-5" style={{ color: 'var(--how-to-icon, #b71b1b)' }} viewBox="0 0 24 24" fill="currentColor">
                          <path d="m10.65 13.4658 5.1429-5.14291 1.4142 1.41421-6.5571 6.5571-3.85711-3.8571 1.41422-1.4142z" />
                          <path d="m12 4c-4.41828 0-8 3.58172-8 8 0 4.4183 3.58172 8 8 8 4.4183 0 8-3.5817 8-8 0-4.41828-3.5817-8-8-8zm-10 8c0-5.52285 4.47715-10 10-10 5.5228 0 10 4.47715 10 10 0 5.5228-4.4772 10-10 10-5.52285 0-10-4.4772-10-10z" />
                        </svg>
                      </dt>
                      <dd className="inline" style={{ color: 'var(--how-to-text, #cccccc)' }}>{text}</dd>
                    </div>
                  ))}
                </dl>

                {/* Ödüller - geçici olarak devre dışı
                {prizesList.length > 0 && (
                  <div className="mt-10">
                    <h3 className="text-3xl sm:text-4xl font-semibold tracking-tight text-white">Ödüller</h3>
                    <dl className="mt-6 max-w-xl space-y-8 text-base text-gray-300 lg:max-w-none">
                      {prizesList.slice(0, 4).map((text, idx) => (
                        <div key={idx} className="relative pl-9">
                          <dt className="inline font-semibold text-white">
                            <svg className="absolute top-1 left-1 w-5 h-5 text-[#b71b1b]" viewBox="0 0 24 24" fill="currentColor">
                              <path d="m10.65 13.4658 5.1429-5.14291 1.4142 1.41421-6.5571 6.5571-3.85711-3.8571 1.41422-1.4142z" />
                              <path d="m12 4c-4.41828 0-8 3.58172-8 8 0 4.4183 3.58172 8 8 8 4.4183 0 8-3.5817 8-8 0-4.41828-3.5817-8-8-8zm-10 8c0-5.52285 4.47715-10 10-10 5.5228 0 10 4.47715 10 10 0 5.5228-4.4772 10-10 10-5.52285 0-10-4.4772-10-10z" />
                            </svg>
                          </dt>
                          <dd className="inline">{text}</dd>
                        </div>
                      ))}
                    </dl>
                  </div>
                )}
                */}

                {/* Teselli Ödülleri - geçici olarak devre dışı
                {consolationTiers.length > 0 && (
                  <div className="mt-8">
                    <h3 className="text-3xl sm:text-4xl font-semibold tracking-tight text-white">Teselli</h3>
                    {consolationDesc && (
                      <p className="mt-2 text-gray-300">{consolationDesc}</p>
                    )}
                    <dl className="mt-6 max-w-xl space-y-8 text-base text-gray-300 lg:max-w-none">
                      {consolationTiers.slice(0, 4).map((text, idx) => (
                        <div key={idx} className="relative pl-9">
                          <dt className="inline font-semibold text-white">
                            <svg className="absolute top-1 left-1 w-5 h-5 text-[#b71b1b]" viewBox="0 0 24 24" fill="currentColor">
                              <path d="m10.65 13.4658 5.1429-5.14291 1.4142 1.41421-6.5571 6.5571-3.85711-3.8571 1.41422-1.4142z" />
                              <path d="m12 4c-4.41828 0-8 3.58172-8 8 0 4.4183 3.58172 8 8 8 4.4183 0 8-3.5817 8-8 0-4.41828-3.5817-8-8-8zm-10 8c0-5.52285 4.47715-10 10-10 5.5228 0 10 4.47715 10 10 0 5.5228-4.4772 10-10 10-5.52285 0-10-4.4772-10-10z" />
                            </svg>
                          </dt>
                          <dd className="inline">{text}</dd>
                        </div>
                      ))}
                    </dl>
                  </div>
                )}
                */}
              </div>
            </div>
            {/* Desktop Image */}
            <img 
              src={settings?.banners?.info || '/bigo-announcer.png'} 
              alt="Product screenshot" 
              className="hidden sm:block w-[48rem] max-w-none rounded-xl shadow-xl ring-white/10 md:w-[57rem] md:-ml-4 lg:-ml-0" 
              width="2432" 
              height="1442" 
            />
            
            {/* Mobile Image */}
            <img 
              src={settings?.banners?.infoMobile || '/bg-image-mobile.webp'} 
              alt="Mobile Product screenshot" 
              className="block sm:hidden w-full max-w-none rounded-xl shadow-xl ring-white/10" 
              width="800" 
              height="600" 
            />
          </div>
        </div>
      </div>

      {/* Winners Popup */}
      {winnersOpen && (
        <div id="winnersPopup" className="fixed inset-0 bg-black/75 flex items-center justify-center z-50 p-0 sm:p-4">
          <div className="bg-[#0d0d0d] popup-container w-full h-screen sm:h-auto max-w-2xl mx-auto relative">
            <div className="p-6 border-b border-gray-800 flex justify-between items-center">
              <h2 className="text-xl font-bold text-white">Temmuz Ayının Kazananları</h2>
              <button id="closePopupBtn" className="text-gray-400 hover:text-white cursor-pointer" onClick={() => setWinnersOpen(false)}>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-8 h-8">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            <div className="tabs-wrapper" id="winnersTableCategories">
              {/* Kategoriler dinamik olarak eklenebilir */}
            </div>
            <div className="p-6 overflow-y-auto scrollbar" style={{ height: 'calc(100vh - 88px)' }}>
              <table className="min-w-full divide-y divide-gray-700" id="winnersTable">
                <thead>
                  <tr>
                    <th className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-white">Sıralama</th>
                    <th className="px-3 py-3.5 text-left text-sm font-semibold text-white">Kullanıcı Adı</th>
                    <th className="px-3 py-3.5 text-left text-sm font-semibold text-white">Kazanılan Ödül</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-800" id="winnersTableBody">
                  {/* Veri eklenecek */}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}

      {/* Tickets Popup */}
      {ticketsOpen && (
        <div id="ticketsPopup" className="fixed inset-0 flex items-center justify-center z-50 p-0 sm:p-4" style={{ background: 'var(--tickets-overlay, rgba(0,0,0,0.75))' }}>
          <div className="popup-container w-full h-screen sm:h-auto max-w-2xl mx-auto relative" style={{ background: 'var(--tickets-popup-bg, #0d0d0d)', border: '1px solid var(--tickets-popup-border, #1f2937)' }}>
            <div className="p-6 border-b flex justify-between items-center" style={{ background: 'var(--tickets-header-bg, transparent)', borderColor: 'var(--tickets-popup-border, #1f2937)' }}>
              <h2 className="text-xl font-bold" style={{ color: 'var(--tickets-header-text, #ffffff)' }}>Biletlerim</h2>
              <button id="closeTicketsBtn" className="text-gray-400 hover:text-white" onClick={() => setTicketsOpen(false)}>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-8 h-8">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            <div className="flex border-b" style={{ borderColor: 'var(--tickets-popup-border, #1f2937)' }}>
              <button className={tabButtonClass('active')} data-tab="active" id="active" onClick={() => setActiveTicketTab('active')} style={{ color: activeTicketTab === 'active' ? 'var(--tickets-tab-active, #ffffff)' : 'var(--tickets-tab-inactive, #9ca3af)' }}>
                {`Bekleyen Biletler (${tickets.active.length})`}
              </button>
              <button className={tabButtonClass('winners')} data-tab="winners" id="winners" onClick={() => setActiveTicketTab('winners')} style={{ color: activeTicketTab === 'winners' ? 'var(--tickets-tab-active, #ffffff)' : 'var(--tickets-tab-inactive, #9ca3af)' }}>
                {`Kazanan Biletler (${tickets.winners.length})`}
              </button>
              <button className={tabButtonClass('loses')} data-tab="loses" id="loses" onClick={() => setActiveTicketTab('loses')} style={{ color: activeTicketTab === 'loses' ? 'var(--tickets-tab-active, #ffffff)' : 'var(--tickets-tab-inactive, #9ca3af)' }}>
                {`Kaybeden Biletler (${tickets.loses.length})`}
              </button>
            </div>
            <div className="p-6 overflow-y-auto scrollbar" style={{ height: 'calc(100vh - 140px)' }}>
              <div id="ticketsContainer" className="flex flex-col gap-4 p-4">
                {tickets[activeTicketTab].length === 0 && (
                  <div className="text-center py-8" style={{ color: 'var(--tickets-empty-text, #9ca3af)', fontSize: '1.1rem' }}>
                    Gösterilecek bilet yok
                  </div>
                )}
                {tickets[activeTicketTab].map((t, idx) => {
                  // Status'a göre renk ve stil belirleme
                  let statusColor = 'var(--tickets-card-border, #374151)';
                  let statusBg = 'var(--tickets-card-bg, transparent)';
                  let statusLabel = '';
                  let statusBadgeBg = '#6b7280';
                  
                  if (activeTicketTab === 'active') {
                    statusColor = '#fbbf24'; // Sarı - bekleyen
                    statusBg = 'rgba(251, 191, 36, 0.05)';
                    statusLabel = '⏳ Bekliyor';
                    statusBadgeBg = '#fbbf24';
                  } else if (activeTicketTab === 'winners') {
                    statusColor = '#10b981'; // Yeşil - kazanan
                    statusBg = 'rgba(16, 185, 129, 0.05)';
                    statusLabel = '🎉 Kazandı';
                    statusBadgeBg = '#10b981';
                  } else if (activeTicketTab === 'loses') {
                    statusColor = '#ef4444'; // Kırmızı - kaybeden
                    statusBg = 'rgba(239, 68, 68, 0.05)';
                    statusLabel = '❌ Kaybetti';
                    statusBadgeBg = '#ef4444';
                  }
                  
                  return (
                    <div 
                      key={idx} 
                      className="ticket" 
                      style={{ 
                        background: statusBg,
                        border: `2px solid ${statusColor}`,
                        borderRadius: '12px',
                        padding: '16px',
                        transition: 'all 0.3s ease',
                        boxShadow: `0 4px 12px ${statusColor}20`
                      }}
                    >
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                        <div className="ticketTitle" style={{ color: 'var(--tickets-card-title, #ffffff)', fontSize: '1.2rem', margin: 0 }}>
                          Bilet No: {t.code}
                        </div>
                        <span style={{ 
                          background: statusBadgeBg,
                          color: '#ffffff',
                          padding: '4px 12px',
                          borderRadius: '20px',
                          fontSize: '0.85rem',
                          fontWeight: '600'
                        }}>
                          {statusLabel}
                        </span>
                      </div>
                      {(t.date || t.amount) && (
                        <div style={{ 
                          display: 'flex', 
                          gap: '16px', 
                          fontSize: '0.9rem',
                          color: 'var(--tickets-card-title, #cccccc)',
                          marginTop: '8px'
                        }}>
                          {t.date && <span>📅 {new Date(t.date).toLocaleDateString('tr-TR')}</span>}
                          {t.amount && <span>💰 {t.amount}</span>}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
          )}

      {/* Admin Popups - Only show when needed */}
      {isAdmin && showAdmin && (
        <AdminLogin onLogin={handleAdminLogin} onClose={handleCloseLogin} />
      )}
      {isAdmin && cssEditorOpen && (
        <>
          {console.log('🎯 Rendering CssEditor component...')}
          <CssEditor onClose={() => setCssEditorOpen(false)} />
        </>
      )}
    </div>
  );
}
